<div class="container">
  <div
    *ngIf="!isBK1 || !isBK2 || !isBK3"
    class="container__background-bk3"
  ></div>
  <div
    *ngIf="isBK1"
    class="container__background-bk1"
  ></div>
  <div
    *ngIf="isBK2"
    class="container__background-bk2"
  ></div>
  <div
    *ngIf="isBK3"
    class="container__background-bk3"
  ></div>
  <div class="container__content">
    <div
      *ngIf="isBK1"
      class="content-bk1"
    >
      <div class="content__text">
        <p class="text">世界に１冊<br />アンパンマンの絵本を<br />贈り物に！</p>
      </div>
      <div class="content__button">
        <lib-button
          color="accent"
          size="sm"
          (buttonClick)="onButtonClick()"
          ><b>ギフトコードで贈る</b></lib-button
        >
      </div>
    </div>
    <div
      *ngIf="isBK2"
      class="content"
    >
      <div class="content__text">
        <p class="text">
          世界に1冊だけの絵本を<br />たいせつな人へのギフトに！
        </p>
      </div>
      <div class="content__button">
        <lib-button
          color="accent"
          size="sm"
          (buttonClick)="onButtonClick()"
          ><b>ギフトコードで贈る</b></lib-button
        >
      </div>
    </div>
    <div
      *ngIf="isBK3"
      class="content-bk3"
    >
      <div class="content__text">
        <p class="text">
          世界に1冊だけの絵本を<br />たいせつな人へのギフトに！
        </p>
      </div>
      <div class="content__button">
        <lib-button
          color="accent"
          size="sm"
          (buttonClick)="onButtonClick()"
          ><b>ギフトコードで贈る</b></lib-button
        >
      </div>
    </div>
    <div
      *ngIf="!isBK1 && !isBK2 && !isBK3"
      class="content-bk3"
    >
      <div class="content__text">
        <p class="text">
          世界に1冊だけの絵本を<br />たいせつな人へのギフトに！
        </p>
      </div>
      <div class="content__button">
        <lib-button
          color="accent"
          size="sm"
          (buttonClick)="onButtonClick()"
          ><b>ギフトコードで贈る</b></lib-button
        >
      </div>
    </div>
  </div>
</div>
